<template>
<div class='cookie-banner'>
        <div class='cookie-banner-contents'>
            <p class="has-text-weight-bold is-size-6">{{$t('Aviso')}}</p>
            <p>{{$t('Este website utiliza cookies necessários ao funcionamento do website ou dos serviços prestados. Com exceção dos cookies necessários, a utilização de cookies depende sempre da sua aceitação.')}}</p>
            <div class="cookie-buttons"></div>
                <div class='cookie-action-buttons'>
                    <b-button
                    native-type="button"
                    type="is-secondary"
                    @click="handleDecline"
                    >
                    {{ $t("Rejeitar") }}
                    </b-button>

                    <b-button
                    native-type="button"
                    type="is-primary"
                    @click="handleAccept"
                    >
                    {{ $t("Aceitar") }}
                    </b-button>
                </div>
                <b-button
                    native-type="button"
                    type="is-secondary"
                    @click="HandleOpenCookieModal"
                    >
                    {{ $t("Política de Cookies") }}
                    </b-button>
        </div>
        <b-modal :active.sync="isCookieModalOpen">
                <cookie-policy-modal @close="handleClose"/>
        </b-modal>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import CookiePolicyModal from './CookiePolicyModal.vue';
export default {
  components: { CookiePolicyModal },
  name: "CookieBanner",
  data() {return {isCookieModalOpen:false}},
  methods:{
      ...mapActions(["updateCookie"]),
      handleClose(){
          this.isCookieModalOpen = false;
      },
      HandleOpenCookieModal(){
          this.isCookieModalOpen = true;
      },
      handleAccept(){
        this.isCookieModalOpen = true;
        this.updateCookie(true)
      },
      handleDecline(){
        this.isCookieModalOpen = true;
        this.updateCookie(false)
      }
  }
}
</script>

<style lang="scss" scoped>
.cookie-banner{
    position:absolute;
    top:0;
    left:0;
    right:0;

    .cookie-banner-contents{
        width:960px;
        margin:0 auto 0 auto;
        background-color: #fff8c5;
        padding: 20px 20px;

    }

    p{
        font-size:13px;
        margin: auto auto 10px auto;
    }

    .cookie-action-buttons{
        float:right;
    }

    .cookie-buttons{
        padding-top: 10px;
    }
}


</style>